import { saveAs } from 'file-saver'
import { formatDate } from './date'

export const downloadMessageFile = messagePayload => {
  const { name = `${formatDate(new Date(), 'dd-MM-yyyy - HH:mm:ss')}`, url } =
    messagePayload

  saveAs(url, name)
}
